import React from "react";
import {Link} from "react-router";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const styles = {
  wrapper: {
    padding: "8px 16px 0px 16px",
  },
  title: {
    marginBottom: "16px",
    fontSize: "1.3rem",
  },
  tabsRoot: {
    borderBottom: "1px solid #e8e8e8",
    minHeight: "40px",
  },
  tabRoot: {
    textTransform: "none",
    minWidth: "120px",
    fontWeight: 400,
    marginRight: 8,
    color: "rgba(0, 0, 0, 0.7)",
    borderRadius: "4px 4px 0 0",
  },
  tabRootSelected: {
    backgroundColor: "#2196f3",
    color: "#fff",
    fontWeight: 500,
  },
} as const;

interface DataAssetsTabsProps {
  currentPath: string;
}

const DataAssetsTabs: React.FC<DataAssetsTabsProps> = ({currentPath}) => {
  const isDefinitionPath = currentPath.includes("/definition/");
  const activeTab = isDefinitionPath ? "create" : currentPath.split("/").pop();
  const basePath = currentPath.split("/data-assets")[0];

  return (
    <div style={styles.wrapper}>
      <h1 style={styles.title}>Data Assets</h1>
      <Tabs
        value={activeTab === "overview" ? 0 : 1}
        style={styles.tabsRoot}
        TabIndicatorProps={{style: {display: "none"}}}
      >
        <Tab
          component={Link}
          to={`${basePath}/data-assets/overview`}
          label="Overview"
          style={{
            ...styles.tabRoot,
            ...(activeTab === "overview" ? styles.tabRootSelected : {}),
          }}
        />
        <Tab
          component={Link}
          to={`${basePath}/data-assets/create`}
          label="Create/View"
          style={{
            ...styles.tabRoot,
            ...(activeTab === "create" || isDefinitionPath
              ? styles.tabRootSelected
              : {}),
          }}
        />
      </Tabs>
    </div>
  );
};

export default DataAssetsTabs;
